module.exports = __webpack_public_path__ + "static/img/IMG_4961.d67a895f.png";